module.exports = __webpack_public_path__ + "static/media/login_imagem.6caf1aed.png";